import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";
import { useScrollToSection } from "../hooks/useScrollToSection.js";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [loansOpen, setLoansOpen] = useState(false);
  const loansDropdownRef = useRef(null);
  const scrollToSection = useScrollToSection();

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const toggleLoans = () => {
    setLoansOpen((prev) => !prev);
  };

  // Close loans dropdown when clicking or touching outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        loansDropdownRef.current &&
        !loansDropdownRef.current.contains(event.target)
      ) {
        setLoansOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  // Close dropdown when location changes
  useEffect(() => {
    setLoansOpen(false);
  }, [location]);

  // Add scroll effect for navbar
  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector(".navbar-header");
      if (navbar) {
        if (window.scrollY > 50) {
          navbar.classList.add("navbar-scrolled");
        } else {
          navbar.classList.remove("navbar-scrolled");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div className="navbar-top-bar">
        <a
          href="tel:+2349037614599"
          style={{
            color: "white",
            textDecoration: "none",
            marginRight: "10px",
          }}
        >
          09037614599
        </a>
        |
        <a
          href="https://wa.me/2349114351195"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "white", textDecoration: "none", marginLeft: "10px" }}
        >
          WhatsApp +234 911 435 1195
        </a>
      </div>

      <header className="navbar-header">
        <div className="navbar-container">
          <div className="navbar-logo">
            <Link to="/">
              <img src="/assets/rsil_logo.png" alt="Respected Solutions Logo" />
            </Link>
          </div>

          <div className="navbar-mobile-menu">
            <div className="navbar-hamburger" onClick={toggleMenu}>
              ☰
            </div>
          </div>

          <div
            className={`navbar-links-container ${
              menuOpen ? "navbar-mobile-show" : ""
            }`}
          >
            <nav>
              <ul className="navbar-menu-list">
                <li className="navbar-menu-item">
                  <Link
                    to="/"
                    className="navbar-menu-link"
                    onClick={() => {
                      scrollToSection("home");
                      setMenuOpen(false);
                    }}
                  >
                    Home
                  </Link>
                </li>

                <li
                  className={`navbar-dropdown ${
                    loansOpen ? "navbar-dropdown-open" : ""
                  }`}
                  ref={loansDropdownRef}
                >
                  <span
                    className="navbar-dropdown-toggle"
                    onClick={toggleLoans}
                  >
                    What We Offer
                  </span>
                  {loansOpen && (
                    <ul className="navbar-dropdown-menu">
                      <li className="navbar-dropdown-menu-item">
                        <Link
                          to="/loan-against-cars"
                          className="navbar-dropdown-menu-link"
                          onClick={() => {
                            setMenuOpen(false);
                            setLoansOpen(false);
                          }}
                        >
                          Loan Against Cars
                        </Link>
                      </li>
                      <li className="navbar-dropdown-menu-item">
                        <Link
                          to="/loan-against-gold"
                          className="navbar-dropdown-menu-link"
                          onClick={() => {
                            setMenuOpen(false);
                            setLoansOpen(false);
                          }}
                        >
                          Loan Against Gold
                        </Link>
                      </li>
                      <li className="navbar-dropdown-menu-item">
                        <Link
                          to="/loan-against-jewelry"
                          className="navbar-dropdown-menu-link"
                          onClick={() => {
                            setMenuOpen(false);
                            setLoansOpen(false);
                          }}
                        >
                          Loan Against Jewelry
                        </Link>
                      </li>
                      <li className="navbar-dropdown-menu-item">
                        <Link
                          to="/loan-against-luxury-watches"
                          className="navbar-dropdown-menu-link"
                          onClick={() => {
                            setMenuOpen(false);
                            setLoansOpen(false);
                          }}
                        >
                          Loan Against Luxury Watches
                        </Link>
                      </li>
                      <li className="navbar-dropdown-menu-item">
                        <Link
                          to="/pawn-park-service"
                          className="navbar-dropdown-menu-link"
                          onClick={() => {
                            setMenuOpen(false);
                            setLoansOpen(false);
                          }}
                        >
                          Pawn & Park Service
                        </Link>
                      </li>
                      <li className="navbar-dropdown-menu-item">
                        <Link
                          to="/money-advice"
                          className="navbar-dropdown-menu-link"
                          onClick={() => {
                            setMenuOpen(false);
                            setLoansOpen(false);
                          }}
                        >
                          Money Advice
                        </Link>
                      </li>
                      <li className="navbar-dropdown-menu-item">
                        <Link
                          to="/wristwatch-repair"
                          className="navbar-dropdown-menu-link"
                          onClick={() => {
                            setMenuOpen(false);
                            setLoansOpen(false);
                          }}
                        >
                          Wristwatch Repair & Jewelry Cleaning
                        </Link>
                      </li>
                      <li className="navbar-dropdown-menu-item">
                        <Link
                          to="/we-buy-we-sell"
                          className="navbar-dropdown-menu-link"
                          onClick={() => {
                            setMenuOpen(false);
                            setLoansOpen(false);
                          }}
                        >
                          We Buy. We Sell
                        </Link>
                      </li>
                      <li className="navbar-dropdown-menu-item">
                        <Link
                          to="/luxury-line-credit"
                          className="navbar-dropdown-menu-link"
                          onClick={() => {
                            setMenuOpen(false);
                            setLoansOpen(false);
                          }}
                        >
                          Luxury Line of Credit
                        </Link>
                      </li>

                      <li className="navbar-dropdown-menu-item">
                        <Link
                          to="/partnership-collaboration"
                          className="navbar-dropdown-menu-link"
                          onClick={() => {
                            setMenuOpen(false);
                            setLoansOpen(false);
                          }}
                        >
                          Partnership & Collaboration
                        </Link>
                      </li>

                      <li className="navbar-dropdown-menu-item">
                        <Link
                          to="/awoof-marketplace"
                          className="navbar-dropdown-menu-link"
                          onClick={() => {
                            setMenuOpen(false);
                            setLoansOpen(false);
                          }}
                        >
                          Awoof Marketplace
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                <li className="navbar-menu-item">
                  <Link
                    to="/"
                    className="navbar-menu-link"
                    onClick={() => {
                      scrollToSection("about");
                      setMenuOpen(false);
                    }}
                  >
                    About Us
                  </Link>
                </li>
                <li className="navbar-menu-item">
                  <Link
                    to="/marketplace"
                    className="navbar-menu-link"
                    onClick={() => setMenuOpen(false)}
                  >
                    Awoof Marketplace
                  </Link>
                </li>
                <li className="navbar-menu-item">
                  <Link
                    to="/blogs"
                    className="navbar-menu-link"
                    onClick={() => setMenuOpen(false)}
                  >
                    Blog
                  </Link>
                </li>
                <li className="navbar-menu-item">
                  <Link
                    to="/careers"
                    className="navbar-menu-link"
                    onClick={() => setMenuOpen(false)}
                  >
                    Careers
                  </Link>
                </li>
                <li className="navbar-menu-item">
                  <Link
                    to="/contact-us"
                    className="navbar-menu-link"
                    onClick={() => setMenuOpen(false)}
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </nav>

            <button
              className="navbar-cta-button"
              onClick={() => {
                navigate("/contact-us");
                setMenuOpen(false);
              }}
            >
              Get Started
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default Navbar;
